import { render, staticRenderFns } from "./create-traceinfo-btn.vue?vue&type=template&id=6c71d5c0&scoped=true&"
import script from "./create-traceinfo-btn.vue?vue&type=script&lang=js&"
export * from "./create-traceinfo-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71d5c0",
  null
  
)

export default component.exports